import { createContext, useContext, useState, useCallback } from 'react';
import { ConfirmModal } from '../components/ui/ConfirmModal';

const ConfirmCtx = createContext(() => Promise.resolve(false));

export function useConfirm() {
  return useContext(ConfirmCtx);
}

export function ConfirmProvider({ children }) {
  const [modal, setModal] = useState(null);

  const showConfirm = useCallback((opts) => new Promise(resolve => {
    setModal({
      ...opts,
      onConfirm: () => { resolve(true); setModal(null); },
      onCancel: () => { resolve(false); setModal(null); },
    });
  }), []);

  return (
    <ConfirmCtx.Provider value={showConfirm}>
      {children}
      <ConfirmModal
        open={!!modal}
        title={modal?.title}
        message={modal?.message}
        danger={modal?.danger}
        onConfirm={() => { modal?.onConfirm(); }}
        onCancel={() => { modal?.onCancel(); }}
      />
    </ConfirmCtx.Provider>
  );
}

export { ConfirmCtx };
